export const initialCompanyData = {
  companyInfo: {
    logo: null,
    companyName: "Acme Insurance Co.",
    companyEmail: "contact@acmeinsurance.com",
    phoneNumber: "+1 (555) 123-4567",
    industry: "Insurance",
    address: "123 Insurance Plaza, New York, NY 10001"
  },
  teamMembers: [
    {
      id: 1,
      name: "Sarah Johnson",
      email: "sarah.johnson@company.com",
      role: "Admin",
      status: "online",
      lastActive: "5 minutes ago",
      avatar: "SJ"
    },
    {
      id: 2,
      name: "Michael Chen",
      email: "michael.chen@company.com",
      role: "Developer",
      status: "online",
      lastActive: "1 hour ago",
      avatar: "MC"
    },
    {
      id: 3,
      name: "Emily Rodriguez",
      email: "emily.rodriguez@company.com",
      role: "Analyst",
      status: "online",
      lastActive: "3 hours ago",
      avatar: "ER"
    },
    {
      id: 4,
      name: "David Kim",
      email: "david.kim@company.com",
      role: "Developer",
      status: "offline",
      lastActive: "2 days ago",
      avatar: "DK"
    }
  ],
  roles: [
    {
      id: 1,
      name: "Admin",
      description: "Full access to all features and settings"
    },
    {
      id: 2,
      name: "Developer",
      description: "Can manage integrations and API configurations"
    },
    { id: 3, name: "Analyst", description: "Can view data and run reports" },
    { id: 4, name: "Viewer", description: "Read-only access to dashboards" }
  ],
  billing: {
    plan: "Enterprise",
    price: "$999/month",
    billingCycle: "Billed annually",
    usage: {
      apiRequests: { used: 50000, limit: 100000 },
      teamMembers: { used: 4, limit: "Unlimited" },
      connectedIntegrations: { used: 5, limit: "Unlimited" }
    },
    paymentMethod: {
      cardNumber: "•••• •••• •••• 4242",
      expiryDate: "12/2025"
    }
  }
};

export const industryOptions = [
  "Insurance",
  "Finance",
  "Healthcare",
  "Technology",
  "Real Estate",
  "Retail",
  "Manufacturing",
  "Other"
];
